import { render, staticRenderFns } from "./last-indications.vue?vue&type=template&id=b0b6893c&scoped=true&"
import script from "./last-indications.vue?vue&type=script&lang=js&"
export * from "./last-indications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6893c",
  null
  
)

export default component.exports